import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import EmptyBlockDropZone from './EmptyBlockDropZone';
import BlockTrailsDropZone from './BlockTrailsDropZone';
import CanvasBlockContainer from './CanvasBlockContainer';
import { blockType } from '../../types';
import * as browserActions from '../../actions/browser';
import * as Styled from './styles';

class Canvas extends PureComponent {
    componentDidMount() {
        const { dispatch, leftPanelCollapsed } = this.props;
        dispatch(browserActions.updateLeftPanelCollapsedStatus(leftPanelCollapsed));
    }

    componentDidUpdate(prevProps) {
        const { dispatch, leftPanelCollapsed } = prevProps;
        const { leftPanelCollapsed: newStatus } = this.props;
        if (leftPanelCollapsed !== newStatus) {
            dispatch(browserActions.updateLeftPanelCollapsedStatus(newStatus));
        }
    }

    render() {
        const { canvasBlocks, isCanvasEmpty } = this.props;

        return (
            <Styled.CanvasWrapper>
                <EmptyBlockDropZone shouldRender={isCanvasEmpty} />
                <Styled.List>
                    {canvasBlocks.map((block, index) => (
                        <CanvasBlockContainer
                            key={block.index}
                            block={block}
                            isFirstBlock={index === 0}
                            stateIndex={index}
                        />
                    ))}
                </Styled.List>
                <BlockTrailsDropZone />
            </Styled.CanvasWrapper>
        );
    }
}

Canvas.propTypes = {
    canvasBlocks: PropTypes.arrayOf(blockType).isRequired,
    isCanvasEmpty: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    leftPanelCollapsed: PropTypes.bool.isRequired,
};

export default connect()(Canvas);
